import React, { useMemo } from "react";
import { useQueryRules } from "react-instantsearch-hooks-web";
import IconVillage from "../ui/icons/IconVillage";
import uniqBy from "../../helpers/uniqBy";

const SearchPromoCommunity = () => {
  const { items } = useQueryRules();

  const communityPromos = useMemo(() => {
    const communityPromos = items.filter(
      (item) => item.promo_type === "community",
    );
    return uniqBy(communityPromos, (promo) => promo.id);
  }, [items]);

  if (communityPromos.length === 0) {
    return null;
  }
  return (
    <div>
      {communityPromos.map((promo) => (
        <div
          key={promo.id}
          className="tw-animate-fade-in tw-bg-aloe tw-px-6 tw-py-5 tw-mb-8"
        >
          <div className="tw-grid md:tw-grid-cols-2 tw-gap-6 tw-min-h-[325px]">
            <div className="tw-relative">
              <div className="tw-w-full sm:tw-w-[80%] tw-h-[80%] ">
                <img src={promo.image_1} alt={promo.community} />
              </div>
              <div className="tw-hidden sm:tw-block tw-absolute tw-bottom-0 tw-right-0 tw-w-[200px]">
                <img src={promo.image_2} alt={promo.community} />
              </div>
            </div>
            <div className="-tw-mt-[18%] sm:tw-mt-0 tw-space-y-1">
              <span className="tw-text-xxxs tw-tracking-wider tw-font-medium tw-uppercase tw-text-charcoal">
                Planned Community
              </span>
              <h2 className="tw-text-charcoal tw-text-2xl">
                {promo.community}
              </h2>
              <div className="tw-flex">
                <span className="tw-font-medium tw-text-sm tw-text-charcoal tw-pr-2">
                  {promo.city},{" "}
                  <span className="tw-uppercase">{promo.state}</span>
                </span>
                <span className="tw-h-4 tw-w-[1px] tw-bg-charcoal"></span>
                <span className="tw-font-medium tw-text-sm tw-text-charcoal tw-pl-2">
                  {promo.price_copy}
                </span>
              </div>
              {promo.neighborhood_count > 0 && (
                <div className="tw-flex tw-items-center">
                  <IconVillage />{" "}
                  <span className="tw-ml-1 tw-font-medium">
                    {promo.neighborhood_count}{" "}
                    {promo.neighborhood_count > 1
                      ? "Neighborhoods"
                      : "Neighborhood"}
                  </span>
                </div>
              )}
              <div>
                {promo.description && (
                  <p className="tw-text-charcoal tw-text-base tw-mt-2 tw-font-medium">
                    {promo.description}
                  </p>
                )}
              </div>
              <div>
                <a
                  className="button full-width margin-vertical tw-cursor-pointer"
                  href={promo.url}
                >
                  <span>Learn More</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default SearchPromoCommunity;
